import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
import {
    ActiveBookingFormTab,
    BookingMode,
    BookingState,
    BookingStep,
    OrderViewMode,
} from './types'
import {
    addBookingAction,
    addEmptyBookingAction,
    addNomenclatureToBookingAction,
    clearBookingStateAction,
    clearExpireInAction,
    editBookingAction,
    removeBookingAction,
    removeNomenclatureToBookingAction,
    replaceBookingTempClientIdToOriginIdAction,
    setActiveBookingIdAction,
    setBookingActiveTabAction,
    setBookingCounterpartyAction,
    setBookingCurrentStepAction,
    setBookingExpireInAction,
    setBookingFormModeAction,
    setBookingFormOrderViewModeAction,
    setBookingIdToEditAction,
    setBookingOrderIdAction,
    setBookingsAction,
    setCommentToBookingAction,
    setContactIdAction,
    setCurrentCalendarEventsAction,
    setIsCompanyAction,
    setIsDirtyAction,
    setIsHistoryModeEnabledAction,
    setIsRedirectForCounterpartyCreationAction,
    setMembersCountToBookingAction,
    setOrderEditStateInitialisingAction,
    setOrderTotalPriceAction,
    setOriginalOrderAction,
    setTodayAction,
    setViewAction,
} from './actions'
import { ViewMode } from '../../../BookingCalendarController/model'

export const initialState: BookingState = {
    currentStep: BookingStep.GeneralInfo,
    mode: BookingMode.Create,
    orderViewMode: OrderViewMode.Preview,
    isHistoryModeEnabled: false,
    activeBookingId: null,
    bookingIdToEdit: null,

    originalOrder: null,
    bookingActiveTab: ActiveBookingFormTab.Booking,
    isEditStateInitialising: false,
    today: moment().toDate().toISOString(),
    view: ViewMode.Day,
    isDirty: false,
    isCompany: null,

    orderId: null,
    counterparty: null,
    totalPrice: null,

    bookings: [],
    currentCalendarEvents: [],

    expireIn: null,

    isRedirectForCounterpartyCreation: false,

    contactId: null,
}

export const bookingSidebarFormSlice = createSlice({
    name: 'bookingSidebarForm',
    initialState,
    reducers: {
        setActiveBookingId: setActiveBookingIdAction,
        setBookingIdToEdit: setBookingIdToEditAction,

        setBookingCurrentStep: setBookingCurrentStepAction,
        clearBookingState: clearBookingStateAction,
        setBookingActiveTab: setBookingActiveTabAction,
        setOrderEditStateInitialising: setOrderEditStateInitialisingAction,

        addBooking: addBookingAction,
        addEmptyBooking: addEmptyBookingAction,
        removeBooking: removeBookingAction,
        editBooking: editBookingAction,

        setBookingCounterparty: setBookingCounterpartyAction,
        setBookingOrderId: setBookingOrderIdAction,
        setMembersCountToBooking: setMembersCountToBookingAction,
        setCommentToBooking: setCommentToBookingAction,
        replaceBookingTempClientIdToOriginId:
            replaceBookingTempClientIdToOriginIdAction,
        addNomenclatureToBooking: addNomenclatureToBookingAction,
        removeNomenclatureToBooking: removeNomenclatureToBookingAction,
        setOrderTotalPrice: setOrderTotalPriceAction,

        setBookingFormMode: setBookingFormModeAction,
        setBookingFormOrderViewMode: setBookingFormOrderViewModeAction,

        setBookings: setBookingsAction,
        setOriginalOrder: setOriginalOrderAction,

        setToday: setTodayAction,
        setView: setViewAction,
        setIsDirty: setIsDirtyAction,
        setIsCompany: setIsCompanyAction,

        setCurrentCalendarEvents: setCurrentCalendarEventsAction,

        setBookingExpireIn: setBookingExpireInAction,
        clearExpireIn: clearExpireInAction,

        setIsHistoryModeEnabled: setIsHistoryModeEnabledAction,

        setIsRedirectForCounterpartyCreation:
            setIsRedirectForCounterpartyCreationAction,

        setContactId: setContactIdAction,
    },
})

export const {
    setActiveBookingId,
    setBookingIdToEdit,
    setBookingCurrentStep,
    clearBookingState,
    setBookingActiveTab,
    setOrderEditStateInitialising,

    addBooking,
    addEmptyBooking,
    removeBooking,
    editBooking,

    setBookingCounterparty,
    setBookingOrderId,
    setMembersCountToBooking,
    setCommentToBooking,
    replaceBookingTempClientIdToOriginId,
    addNomenclatureToBooking,
    removeNomenclatureToBooking,
    setOrderTotalPrice,

    setBookingFormMode,
    setBookingFormOrderViewMode,
    setBookings,
    setOriginalOrder,

    setToday,
    setView,
    setIsDirty,
    setIsCompany,

    setCurrentCalendarEvents,

    setBookingExpireIn,
    clearExpireIn,

    setIsHistoryModeEnabled,
    setIsRedirectForCounterpartyCreation,

    setContactId,
} = bookingSidebarFormSlice.actions

export default bookingSidebarFormSlice.reducer
